import {useContext, useEffect} from 'react';

import {AppContext} from '../../../AppModule/Context';

import VIDABOO_CONSTANTS from '../../../config/consts';

const WindowResizerComponent = () => {
  const context = useContext(AppContext);

  useEffect(() => {
    window.addEventListener('resize', handleWindowResize);
    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const handleWindowResize = () => {
    if (window.innerWidth <= VIDABOO_CONSTANTS.RESPONSIVE_BREAKPOINTS.MOBILE) {
      context.setWindowScreenSize(VIDABOO_CONSTANTS.SCREEN_SIZE.MOBILE);
    } else {
      context.setWindowScreenSize(VIDABOO_CONSTANTS.SCREEN_SIZE.DESKTOP);
    }
  };

  return null;
};

export default WindowResizerComponent;
